import React from 'react';

import {LoadingOverlay} from '@homeaway/react-loading-overlay';

// LoadingOverlay.whyDidYouRender = true;

import {useComponent} from './hooks';

import './SearchSubmitSummaryButtonField.less';

function SearchSubmitSummaryButtonField() {
    const {
        className,
        ButtonIcon,
        type,
        label,
        srOnlyLabel,
        disabled,
        loading,
        onClick
    } = useComponent();

    return (
        <div className={className}>
            <ButtonIcon
                type={type}
                label={label}
                srOnlyLabel={srOnlyLabel}
                disabled={disabled}
                onClick={onClick}
            >
                <LoadingOverlay loading={loading}/>
            </ButtonIcon>
        </div>
    );
}

SearchSubmitSummaryButtonField.whyDidYouRender = true;

export {SearchSubmitSummaryButtonField};
